import logActionsMiddleware from './LogActionsMiddleware';
import { asyncActionMiddleware } from '@Utils/Redux/asyncAction';


import thunk from 'redux-thunk';

const devMiddlewares = __DEV__ ?
  [
    logActionsMiddleware,
  ] :
  [];

export default [ // order important
  asyncActionMiddleware,
  thunk,
  ...devMiddlewares,
];
